var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { observer } from "mobx-react";
import { ProductsWrap, GridMoreBaseBox } from "./styles";
import Loading from "../../components/Loading";
import ScrollLoad from "../../components/ScrollLoad";
import { ProductCard } from "./ProductCard";
import ProductTags from "./ProductTags";
import ProductStore from "./store";
import { isNotBlankArray } from "../../../utils/array";
import { transformGridWidth2Number, getCellWidthByGrid as getProductCardPosterWidth, } from "../../utils/size";
import { ModuleLayoutStyle } from "../../../services/playground";
import { isInWindowView } from "../../../utils/browser";
import { ProductCards } from "./NewProductCards";
let WebProducts = class WebProducts extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.contentRef = React.createRef();
        this.hasListener = false;
        this.scrollTop = 0;
        this.preProductIndex = 0;
        this.onScroll = () => {
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = setTimeout(this.isScrollEnd, 600);
            this.scrollTop = window.scrollY || window.pageYOffset;
        };
        this.isScrollEnd = () => {
            const endTop = window.scrollY || window.pageYOffset;
            const placeHolderCurrent = this.contentRef.current;
            if (endTop === this.scrollTop && isInWindowView(placeHolderCurrent)) {
                this.trackOnShow();
            }
        };
        this.trackOnShow = () => {
            const { SetCtrTrackOnShow, SetGtmTrackOnShow } = this.props;
            const { showedProducts } = this.state;
            if (showedProducts.length > 0 && (SetCtrTrackOnShow || SetGtmTrackOnShow)) {
                let posArr = [];
                let pidsArr = [];
                showedProducts.forEach((item, i) => {
                    posArr.push(i + 1 + this.preProductIndex);
                    pidsArr.push(item.gpid);
                });
                SetCtrTrackOnShow && SetCtrTrackOnShow(posArr.join(","), pidsArr);
                SetGtmTrackOnShow && SetGtmTrackOnShow(showedProducts, posArr);
                this.preProductIndex = this.preProductIndex + showedProducts.length;
                this.setState({ showedProducts: [] });
            }
        };
        this.productCardWidth = () => {
            const { layout, width, minWidth } = this.props;
            const { gap = 12, columnNum = 4 } = layout;
            const contentWidth = transformGridWidth2Number(width || 1200, minWidth);
            return getProductCardPosterWidth({
                contentWidth,
                gridCol: columnNum,
                gridGap: gap,
            });
        };
        this.onTagsChange = (category, index, fixed) => __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            if (this.props.onClickTab) {
                this.props.onClickTab(index);
            }
            this.setState({
                activeTab: category.id,
                showedProducts: [],
            });
            if (!isNotBlankArray(this.productStore.productsListMap[category.id])) {
                this.setState({
                    isChangeTab: true,
                });
                yield this.onLoadMoreProducts(category.id)();
                if (category.id) {
                    this.setState({
                        activeTab: category.id,
                        isChangeTab: false,
                    });
                }
                this.preProductIndex = 0;
            }
            if (fixed) {
                const offsetTop = ((_c = (_b = this.contentRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0;
                const { stickToTop = 0 } = this.props;
                window.scrollTo(0, offsetTop - stickToTop);
            }
            else {
                this.trackOnShow();
            }
        });
        this.onLoadMoreProducts = (poolId) => () => __awaiter(this, void 0, void 0, function* () {
            if (poolId) {
                const nextProducts = (yield this.productStore.loadProductsList(poolId, this.props.onLoadPool)) || [];
                this.productStore.productsListMap[poolId];
                this.setState({
                    showedProducts: [...this.state.showedProducts, ...nextProducts],
                });
            }
        });
        this.onClickProduct = (post, pid) => {
            this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(post, pid);
        };
        this.renderList = (poolId) => {
            const { layout, posterRatio, placeholderBg } = this.props;
            const { columnNum = 4 } = layout;
            const productCardWidth = this.productCardWidth();
            const { productsListMap = {} } = this.productStore;
            const products = productsListMap[poolId];
            if (!products) {
                return null;
            }
            return products.map((item, index) => {
                return (React.createElement(ProductCard, { key: index, product: Object.assign({}, item), width: `${productCardWidth}px`, posterRatio: posterRatio, gridCol: columnNum, placeholderBg: placeholderBg, onClick: () => this.onClickProduct((index + 1).toString(), item.gpid), layoutStyle: this.props.layoutStyle || ModuleLayoutStyle.Orange }));
            });
        };
        this.renderBody = () => {
            const { layout, layoutStyle = ModuleLayoutStyle.Tomato, posterRatio, placeholderBg, } = this.props;
            const { gap = 12, columnNum = 4 } = layout;
            const { isChangeTab, activeTab: poolId } = this.state;
            const loading = poolId ? this.productStore.isLoadingProducts[poolId] : false;
            const { productsListMap = {} } = this.productStore;
            const products = productsListMap[poolId];
            if (isChangeTab) {
                return React.createElement(Loading, null);
            }
            if (layoutStyle === ModuleLayoutStyle.Tomato) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(ProductCards, { posterRatio: posterRatio || 1, typeUI: layoutStyle, col: columnNum, products: products, placeholderBg: placeholderBg }),
                    loading && React.createElement(Loading, null)));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(GridMoreBaseBox, { gridCol: columnNum, gridGap: gap, width: this.productCardWidth() }, this.renderList(poolId)),
                loading && React.createElement(Loading, null)));
        };
        this.productStore = new ProductStore(props.productModules);
        const activeTab = props.activeTab || ((_a = props.productModules[0]) === null || _a === void 0 ? void 0 : _a.poolId);
        this.state = {
            activeTab,
            isChangeTab: false,
            showedProducts: this.productStore.productsListMap[activeTab] || [],
        };
    }
    componentDidMount() {
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    render() {
        const { stickToTop, positionId = "", tagGroup = [], canScrollFixed, width = "", } = this.props;
        const poolId = this.state.activeTab;
        return (React.createElement(ProductsWrap, { id: positionId, gridWidth: +width, ref: this.contentRef },
            isNotBlankArray(tagGroup) && (React.createElement(ProductTags, { stickToTop: stickToTop, canScrollFixed: canScrollFixed, onChange: this.onTagsChange, activeTab: poolId, tagGroup: tagGroup, width: this.props.width })),
            React.createElement(ScrollLoad, { onLoadMore: this.onLoadMoreProducts(poolId), targetRef: this.contentRef }, this.renderBody())));
    }
};
WebProducts.defaultProps = {
    stickToTop: 0,
    productModules: [],
    layout: {
        gap: 12,
        columnNum: 4,
    },
};
WebProducts = __decorate([
    observer
], WebProducts);
export default function ProductExposed(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(WebProducts, Object.assign({}, props))));
}
